import MonthlyBookChart from './MonthlyBookChart'
import { MonthlyBookResponse, MonthlyBookRow } from './deliveryChartsContract'

/**
 * The 1H / 2H / Total summary columns from the monthly-book payload, split out
 * of MonthlyBookChart into their own chart. Same funnel + rate-line rendering;
 * only the rows differ (res.totals instead of res.months). Shares the single
 * monthly-book request (the fetch dedupes per endpoint).
 */
export default class MonthlyBookTotalsChart extends MonthlyBookChart {
  public title: string = 'Sold / Foundry Booked / Delivered — 1H / 2H / Total'

  public key: string = 'delivery-monthly-book-totals'

  protected selectRows(res: MonthlyBookResponse): MonthlyBookRow[] {
    return res.totals || []
  }
}
